(function () {
  "use strict";

  angular
    .module("admin.sets.waitlist.service", [])
    .factory("AdminSetsWaitlistService", AdminSetsWaitlistService);

  /** @ngInject */
  function AdminSetsWaitlistService($http, $q, API) {
    function list(id, start, limit, sort) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/channels/" +
            id +
            "/waitlists/users?start=" +
            start +
            "&limit=" +
            limit +
            "&sort=" +
            sort
        )
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    return {
      list: list,
    };
  }
})();
